<template>
    <div class="page-content cerere-finantare-wrapper">
        <SketchBreadcrumb pageName="Cerere de finanțare"></SketchBreadcrumb>
        <div ref="parent_div" class="padding-box" @scroll="handleScroll">
            <div ref="scrollTo" class="cerere-menu">
                <router-link v-for="(page, key) in cfpages" :key="key" :to="page.link" class="cerere-menu-item" :class="[page.done ? 'done-item' : '', $route.fullPath.includes(page.link) ? 'active-item' : '']">
                    <b-icon-check v-if="page.done" font-scale="1.8" class="green-text mr-1"></b-icon-check>
                    <span :style="page.done ? { color: '#000000' } : {}">{{ key+1 }}. {{ page.title.substring(0, 17) }}<span v-if="page.title.length > 17">...</span></span>
                </router-link>
            </div>
            <div class="white-box">
                <!--                <div class="title-div">-->
                <!--                    <h3>Cerere de finanțare</h3>-->
                <!--                </div>-->

                <div class="cfpage-content">
                    <router-view :data="allData" :checkScroll="checkScroll" :companies="companies" :termeneV1="termeneV1" :termeneV2="termeneV2" :termeneV3="termeneV3" :indicators="statistics" :states="states" :m3-grant-application="m3GrantApplication" :responsabilProiect="responsabilProiect" :bugetData="bugetData" @savedData="getCFData()" @responsabilProiect="responsabilProiect = $event"></router-view>
                    <!--<LoadingSpinner v-else style="min-height: 300px;"></LoadingSpinner>-->
                </div>
            </div>
            <b-icon-chevron-up class="back-to-top" @click="scrollToTop()"></b-icon-chevron-up>
        </div>
    </div>
</template>
<script>
    import LoadingSpinner from '@/common/components/LoadingSpinner';
    import { BIconInfoCircle, BIconCheck, BIconChevronUp } from "bootstrap-vue";
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';

    export default {
        components: {
            LoadingSpinner,
            BIconInfoCircle,
            SketchBreadcrumb,
            BIconCheck,
            BIconChevronUp
        },
        data(){
            return{
                checkScroll: false,
                loading: true,
                m3GrantApplication: null,
                responsabilProiect: null,
                cfpages: [
                    {
                        title: 'Solicitant',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/solicitant',
                        done: false
                    },
                    {
                        title: 'Atribute proiect',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/atribute-proiect',
                        done: false
                    },
                    {
                        title: 'Responsabil de proiect',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/responsabil-proiect',
                        done: false
                    },
                    {
                        title: 'Persoana de contact',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/persoana-de-contact',
                        done: false
                    },
                    {
                        title: 'Capacitate solicitant',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/capacitate-solicitant',
                        done: false
                    },
                    {
                        title: 'Localizare proiect',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/localizare-proiect',
                        done: false
                    },
                    {
                        title: 'Obiective proiect',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/obiective-proiect',
                        done: false
                    },
                    {
                        title: 'Rezultate așteptate',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/rezultate-asteptate',
                        done: false
                    },
                    {
                        title: 'Context',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/context',
                        done: false
                    },
                    {
                        title: 'Justificare',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/justificare',
                        done: false
                    },
                    {
                        title: 'Sustenabilitate',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/sustenabilitate',
                        done: false
                    },
                    {
                        title: 'Riscuri',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/riscuri',
                        done: false
                    },
                    {
                        title: 'Principii orizontale',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/principii-orizontale',
                        done: false
                    },
                    {
                        title: 'Metodologie',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/metodologie',
                        done: false
                    },
                    {
                        title: 'Descrierea investitiei',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/descrierea-investitiei',
                        done: false
                    },
                    {
                        title: 'Maturitatea proiectului',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/maturitatea-proiectului',
                        done: false
                    },
                    {
                        title: 'Nerespectare legislatie UE',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/nerespectare-legislatie-ue',
                        done: false
                    },
                    {
                        title: 'Indicatori prestabiliti',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/indicatori-prestabiliti',
                        done: false
                    },
                    {
                        title: 'Indicatori suplimentari',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/indicatori-suplimentari',
                        done: false
                    },
                    {
                        title: 'Plan de achizitii',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/plan-achizitii',
                        done: false
                    },
                    {
                        title: 'Resurse umane implicate',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/resurse-umane',
                        done: false
                    },
                    {
                        title: 'Resurse materiale implicate',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/resurse-materiale',
                        done: false
                    },
                    {
                        title: 'Activitati previzionate',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/activitati-previzionate',
                        done: false
                    },
                    {
                        title: 'Buget - Activități și cheltuieli',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/buget-activitati-cheltuieli',
                        done: false
                    },
                    {
                        title: 'Buget - Plan anual de cheltuieli',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/buget-plan-anual-cheltuieli',
                        done: false
                    },
                    {
                        title: 'Buget - Amplasament',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/buget-amplasament',
                        done: false
                    },
                    {
                        title: 'Buget - Câmp de intervenție',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/buget-camp-interventie',
                        done: false
                    },
                    {
                        title: 'Buget - Tip de finanțare',
                        link: '/aplicatii/m3-sketch/cerere-de-finantare/buget-tip-finantare',
                        done: false
                    },
                ],
                termeneV1: [],
                termeneV2: [],
                termeneV3: [],
                indicators: [],
                states: [],
                bugetData: [],
            }
        },
        computed: {
            completedPages() {
                return this.$store.getters['finantare/progress'];
            },
            statistics() {
                return this.$store.getters['m3Sketch/indicators']
            },
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch: {
            completedPages: {
                handler: function () {
                    this.cfpages.forEach(page => {
                        page.done = this.completedPages.includes(page.title);
                    })
                    if(this.completedPages.length === 28) {
                        // this.$store.dispatch('checks/updateChecks', {name: 'cerereDeFinantare', value: true})
                        this.$store.dispatch('pages/addPage', {section: 'cerere-de-finantare'})
                    }
                    else{
                        // this.$store.dispatch('checks/updateChecks', {name: 'cerereDeFinantare', value: false})
                        this.$store.dispatch('pages/removePage', {section: 'cerere-de-finantare'})
                    }
                }
            }
        },
        mounted() {
            axios.get(api.API_ROOT + '/states-full/RO')
                .then( response => {
                    this.states = response.data
                })
                .catch( xhr => {
                    console.log(xhr);
                })
            this.getCFData()
            this.getBusinessData()
            this.getBudgetData()
            this.$store.dispatch('finantare/initializeProgress');

            /*this.$swal({
                heightAuto: false,
                title: 'Încă lucrăm la această funcționalitate.<br>' +
                    '<p style="font-size: 14px; text-align: center; margin-top: 15px;">Te rugăm să nu completezi încă aceste câmpuri.</p>',
                icon: 'info',
            })*/
        },
        methods: {
            getBusinessData() {
                axios.get(api.API_ENDPOINTS.m3 + ( JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).business_id : 0) + '/v1')
                    .then(response => {
                        this.termeneV1 = response.data
                        axios.get(api.API_ENDPOINTS.m3 + ( JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).business_id : 0) + '/v2')
                            .then(response2 => {
                                this.termeneV2 = response2.data
                                axios.get(api.API_ENDPOINTS.m3 + ( JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).business_id : 0) + '/v3')
                                    .then(response3 => {
                                        this.termeneV3 = response3.data
                                        this.$store.dispatch('pageLoading/setLoading', false)
                                    })
                            })
                    })
            },
            getCFData() {
                axios.get(api.API_ENDPOINTS.m3company + (JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).id : 0) + '/grant-application')
                    .then( (response) => {
                        this.m3GrantApplication = response.data;
                    })
            },
            getBudgetData() {
                axios.get(api.API_ENDPOINTS.m3company + (JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).id : 0) + '/project/indicators')
                    .then( response => {
                        this.bugetData = response.data
                    })
            },

            scrollToTop() {
                this.$refs.scrollTo.scrollIntoView({behavior: 'smooth', block: "center"});
            },
            handleScroll(){
                this.checkScroll = this.$refs.parent_div.scrollTop > 0.13 * this.$refs.parent_div.scrollHeight;
            }
        }
    }
</script>

<style scoped>
.back-to-top{
    cursor: pointer;
    position: sticky;
    bottom: -10px;
    left: 100%;
    color: #fff;
    z-index: 9;
    padding: 4px;
    border-radius: 4px;
    font-size: 25px;
    background: #8c6984;
}
/* NOT ADMIN */
ul{
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 10px;
    width: 100%;
}
ul li a{
    font-size: 13px;
    background-image: linear-gradient(to bottom, #8c6984, #816e8b);
    color: #fff;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 5px 7px;
    white-space: nowrap;
    text-align: center;
}
li a:hover{
    text-decoration: none;
}
/* ADMIN */

.title-div{
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
}
.title-div h3{
    font-size: 25px;
    color:#aa93a8;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.flex{
    display: flex;
}
.flex-column{
    flex-direction: column;
}
p{
    font-size: 14px;
}

.purple-title{
    font-size: 18px;
    color: #846c88;
    font-weight: 600;
}
.desc-text{
    font-size: 13px;
    color: #778093;
}
.cerere-menu{
    display: grid;
    margin: -20px -20px 20px -20px;
    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
    background: linear-gradient(to bottom, #65586e, #5d5b6e);
}
.cerere-menu-item{
    min-height: 38px;
    border: 1px solid #dfdfdf;
    color: #fff;
    font-size: 11px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-weight: 500;
    transition: 0.1s;
    cursor: pointer;
}
.cerere-menu-item:hover{
    background: #8c6984;
    color: #fff;
    text-decoration: none;
}
.active-item{
    background: #8c6984 !important;
    color: #fff !important;
}
.active-item span, .cerere-menu-item:hover span{
    color: #fff !important;
}
.done-item{
    background: #cefff8;
}
.green-text{
    color: #49cda8 !important;
}

>>> .info-text{
    color: #826d8a;
    font-size: 14px;
    margin-bottom: 40px;
}
>>> .info-text a{
    text-decoration: none;
    color: #826d8a;
    font-weight: 600;
}
>>> .purple-title-bold{
    font-weight: 700;
    color: #8b6a85;
    font-size: 16px;
    margin: 15px 0;
}
>>> .form-group legend{
    text-align: right;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
}
>>> .form-group input{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
>>> .form-group input:read-only{
    background: #d1f5ea;
    color:#b2b6be;
}
>>> .switch-box{
    text-align: right;
    margin-top: 25px;
    cursor: pointer;
}
>>> .switch-box input, >>> .switch-box label{
    cursor: pointer;
}
>>> .switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
>>> textarea{
    font-size: 12px;
}
>>> table .blue-head{
    background: #bdd6ee;
    font-size: 14px !important;
    border: 1px solid #979696;
}
>>> table td, >>> table th{
    border: 1px solid #979696;
    font-size: 12px;
}
>>> table thead th {
    vertical-align: middle;
}
>>> thead th, >>> tr td{
    border: 1px solid #c9c9c9 !important;
}
</style>
<style>
textarea:read-only,
table input:read-only{
    background: #d1f5ea!important;
    color: #b2b6be!important;
}
.cerere-finantare-wrapper {
    position: relative;
}
@media screen and (max-width: 1441px) {
    .cerere-finantare-wrapper .modify-res {
        justify-content: space-between!important;
    }
    .cerere-finantare-wrapper .form-group .form-row {
        flex-direction: column;
        align-items: flex-start!important;
    }
    .cerere-finantare-wrapper .custom-responsive {
        width: 100%!important;
    }
    .cerere-finantare-wrapper .alege-asociat {
        flex-direction: column;
    }
    .cerere-finantare-wrapper .alege-asociat p {
        width: 100%;
        text-align: left;
        margin-right: 0px!important;
    }
    .cerere-finantare-wrapper .alege-asociat .w-96 {
        width: 100%!important;
    }
    .cerere-finantare-wrapper .custom-responsive legend {
        max-width: 100%;
        text-align: left;
    }
    .cerere-finantare-wrapper .custom-responsive input {
        max-width: 100%;
    }
    .cerere-finantare-wrapper .w-100,
    .cerere-finantare-wrapper .custom-responsive .col-lg-9,
    .cerere-finantare-wrapper .custom-responsive .col-lg-8{
        max-width: 100% !important;
    }
    .cerere-finantare-wrapper .w-48 {
        max-width: 48%!important;
        width: 48% !important;
    }
    .cerere-finantare-wrapper .v-50 {
        max-width: 50% !important;
        width: 50% !important;
    }
    .cerere-finantare-wrapper .w-32 {
        max-width: 32% !important;
        width: 32% !important;
    }
}
</style>
